import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SCROLL_ROOT_SELECTORS = [
  '[data-scroll-root="aixue-phonics"]',
  '[data-scroll-root="aixue-ai-scroll"]',
  '[data-scroll-root="aixue-about"]',
  '.aixue-about-scroll',
];

function scrollToTop() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      for (const sel of SCROLL_ROOT_SELECTORS) {
        const node = document.querySelector(sel) as HTMLElement | null;
        if (node) node.scrollTo({ top: 0, behavior: 'auto' });
      }
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  });
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return null;
}
